module.exports = __webpack_public_path__ + "bbcd10ca608c49e29ec31e28f0114c5a.svg";